<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title>
          {{
            typeEvent._id
              ? $t('titles.global.updateModel', {
                  field: $tc('models.typeEvent'),
                })
              : $t('titles.global.newModel', { field: $tc('models.typeEvent') })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn icon dark @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap>
          <v-flex d-flex xs12 px-2>
            <translation-field
              ref="name"
              v-model="typeEvent.name"
              :label="$t('fields.global.name')"
            />
          </v-flex>
          <v-flex md4 xs12 px-2>
            <v-select
              v-model="typeEvent.type"
              v-validate="'required'"
              :items="eventTypes"
              :label="
                $t('action.actions.select', {
                  field: $t('fields.global.type'),
                }) + ' (*)'
              "
              :data-vv-name="$t('fields.global.type')"
              :error-messages="errors.collect($t('fields.global.type'))"
              multiple
            />
          </v-flex>
          <v-flex md4 xs12 px-2>
            <v-select
              v-model="typeEvent.group"
              :items="eventGroups"
              :label="
                $t('action.actions.select', {
                  field: $tc('models.group'),
                })
              "
            />
          </v-flex>
          <v-flex md4 xs12 px-2>
            <v-switch
              v-model="typeEvent.vote"
              :label="$t('fields.events.vote')"
              color="primary"
            />
          </v-flex>
          <v-flex xs12 pa-2>
            <button-upload
              :label="$t('fields.users.image')"
              :image.sync="image"
              :title.sync="titleFile"
              @file="(fileResult) => (file = fileResult)"
            />
          </v-flex>

          <!-- <v-flex md4 xs12 px-2>
            <step-information :typeEvent.sync="typeEvent" :file.sync="file" ref="stepInformation" />
          </v-flex>-->
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <span style="color: red">(*) &nbsp;</span>
        <span>{{ $t('action.messages.fieldRequired') }}</span>
        <v-spacer />
        <meta-button type="reset" :disabled="loading" @click="clear" />
        <meta-button
          v-if="!typeEvent._id"
          type="create"
          :loading="loading"
          @click="submit()"
        />
        <meta-button
          v-else
          type="update"
          :loading="loading"
          @click="submit()"
        />
        <meta-button type="cancel" @click="cancel" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import TranslationField from '@/components/widgets/Input/TranslationField'
import ButtonUpload from '@/components/widgets/button/ButtonUpload'
import { parseObject } from '@/helpers/utils'

export default {
  name: 'TypeEventForm',
  components: {
    TranslationField,
    ButtonUpload,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    typeEventId: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      typeEvent: {},
      file: '',
      image: '',
      titleFile: '',
    }
  },
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
    selected: {
      handler: function (val) {
        if (val) this.typeEvent = parseObject(val)
        this.typeEvent.name = val.name
      },
      immediate: true,
      deep: true,
    },
    'typeEvent.icon': {
      handler: function (val) {
        if (val) {
          if (val.includes('http')) this.image = val
          else this.image = this.defaultValues.imageUrl + val
        } else {
          this.image = ''
        }

        this.titleFile = val
        this.file = ''
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.typeEvent = parseObject(this.selected)
    this.typeEvent.name = this.selected.name
  },
  computed: {
    ...mapState({
      selected: (state) => state.typeEvents.selected,
      loading: (state) => state.typeEvents.loading,
    }),
    ...mapGetters({
      eventTypes: 'typeEvents/types',
      eventGroups: 'typeEvents/groups',
      permissionSelectList: 'typeEvents/permissionSelectList',
    }),
  },
  methods: {
    ...mapActions({
      setCreate: 'typeEvents/create',
      setUpdate: 'typeEvents/update',
      reset: 'typeEvents/reset',
      uploadFile: 'files/uploadPush',
    }),
    submit() {
      Promise.all([this.validate(), this.$refs.name.validate()]).then(
        (valid) => {
          if (valid.some((valid) => !valid)) return

          let payload = Object.assign({}, this.typeEvent)
          if (!payload._id) {
            this.setCreate(payload).then((item) => {
              if (this.file) {
                this.uploadFile({
                  id: item._id,
                  model: 'Typeevents',
                  field: 'icon',
                  file: this.file,
                })
              }
              this.cancel()
            })
          } else {
            this.setUpdate(payload).then((item) => {
              if (this.file) {
                this.uploadFile({
                  id: item._id,
                  model: 'Typeevents',
                  field: 'icon',
                  file: this.file,
                })
              }
              this.cancel()
            })
          }
        }
      )
    },
    cancel() {
      this.$emit('close')
      this.clear()
    },
    clear() {
      this.$nextTick((_) => {
        this.file = ''
        this.image = ''
        this.titleFile = ''
        this.reset()
        this.$validator.reset()
        if (this.$refs.name) this.$refs.name.$validator.reset()
      })
    },
  },
}
</script>
